<template>
<v-dialog v-model="dialog" max-width="640px" persistent>
    <v-card>
        <v-form ref="form" v-model="valid">
            <v-card-text :style="{background: service.color}"></v-card-text>
            <v-card-text>
                <v-text-field label="Color" v-model="service.color" :rules="rules.color" required hint="Color must be formatted like `#000` or `#000000`." persistent-hint />
                <v-text-field label="Slug" v-model="service.slug" :rules="rules.slug" required hint="Slug must be a unique, can only contain letters, numbers & underscores." persistent-hint />
                <v-text-field label="Name" v-model="service.name" :rules="rules.name" required hint="Service name." persistent-hint />
                <v-text-field label="Description" v-model="service.description" :rules="rules.description" required hint="Service description." persistent-hint />
                <small>* indicates a required field</small>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="emitExit()">Cancel</v-btn>
                <v-btn color="primary" @click="save" :loading="loading_save" :disabled="!valid">Save</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</v-dialog>
</template>

<script>
import defaults from "../../utils/PropDefaults.js";

export default {
    components: {},

    props: {
        dialog: {
            type: Boolean,
            default: true
        },
        item_id: [Number, String],

    },
    data() {
        return {
            // service
            service: this.$clone(defaults.service_item),

            loading_save: false,

            valid: false,
            rules: {
                color: [
                        v => !!v || 'Color is required.',
                        v => /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(v) || 'Not a valid hex code.'
                      ],
                slug: [
                        v => !!v || 'Slug is required',
                        v => /^[A-Za-z0-9]+(?:_[A-Za-z0-9]+)*$/.test(v) || 'Not a valid slug, must only contain letters, numbers & underscores.'
                      ],
                name: [v => !!v || 'Name is required'],
                description: [v => !!v || 'Description is required']
            },

            //validation
            valid_service: false,
            valid_role: false,


        }
    },
    watch: {
        item_id: {
            handler() {
                if(this.item_id) {
                    this.getItem();
                } else {
                    this.service = this.$clone(defaults.service_item);
                }
            }
        },
    },

    methods: {

        getItem() {
            if(!this.item_id) {
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/roles/services/' + this.item_id;

            this.$axios.get(endpoint)
                .then(response => {
                    this.service = response.data;
                })
                .catch(error => {
                    console.log(error);
                })
        },

        save() {
            // validate
            if(!this.$refs.form.validate()) {
                return
            }

            // we are loading
            this.loading_save = true;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/roles/services';

            // call update or save endpoints
            if(this.service.id) {
                this.$axios.put(endpoint + '/' + this.service.id, this.service) // eslint-disable-next-line
                    .then(response => {
                        this.emitExit();
                    })
                    .catch(error => {
                        this.error('Oops, something went wrong!');
                        console.error(error);
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });
            } else {
                this.$axios.post(endpoint, this.service) // eslint-disable-next-line
                    .then(response => {
                        this.emitExit();
                    })
                    .catch(error => {
                        this.error('Oops, something went wrong!');
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });
            }
        },

        emitExit() {
            this.service = this.$clone(defaults.service_item);
            this.$refs.form.reset();
            this.$emit('exit')
        },

    }
}
</script>
